import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { LogoutSuccessSVG, CoverageSVG } from '../../../../img/GlobalSVG';
import GenericButton from '../../../../../Components/GenericButton/GenericButton';

const EnrollmentSuccess = () => {
  const navigate = useNavigate();

  const goToDashboardPage = () => {
    navigate('/admin/admin-dashboard');
  };
  return (
    <Container className="enrollment-success-container text-center">
      <Row>
        <Col>
          <LogoutSuccessSVG.LogoutSuccessSVG />
        </Col>
      </Row>
      <Row>
        <Col className="d-flex justify-content-center">
          <div className="content-box">
            <h1 className="enrollment-success-title">
              Thank You, your enrollment request has been received!
            </h1>
            <p className="mb-0">
              We will review your information and send you an update confirming
              your enrollment status!
            </p>
            <GenericButton
              onClick={goToDashboardPage}
              variant="primary"
              className="dashboard-button d-flex mx-auto text-center "
            >
              DASHBOARD
            </GenericButton>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="did-you-know-container-box d-flex">
            <CoverageSVG.BulbSVG />
            <div className="content-box text-left">
              <h4>Did you know?</h4>
              <p>
                If you are physically tired, the best thing to do is exercise as
                it will give you more energy than sitting.
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default EnrollmentSuccess;
